import { useSelector } from 'react-redux';

import { usePrivateBoardStats } from '~/components/v2/hooks/queries/usePrivateBoardsStats';
import { useViewsSelectAllStore } from '~/components/v2/store/features/views/useViewsSelectAllStore';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { centralizedBoardIdSelector } from '~/store/centralizedBoard/selectors';

export const usePrivateSelectAllTotalCount = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const currentBoardId = useSelector(centralizedBoardIdSelector);
  const selectAll = useViewsSelectAllStore((state) => state.selectAll);
  const includeNestedItems = useViewsSelectAllStore((state) => state.includeNestedItems);
  const selectAllRootBoardId = useViewsSelectAllStore((state) => state.selectAllRootBoardId);

  const boardId = selectAll ? selectAllRootBoardId : currentBoardId;
  const includeDescendants = selectAll ? includeNestedItems : false;

  const { data: stats } = usePrivateBoardStats(
    {
      boardId,
      workspaceId: currentWorkspace?.id,
      includeDescendants,
    },
    { keepPreviousData: true },
  );

  return stats ? (stats.assetCount ?? 0) + (stats.fileCount ?? 0) : undefined;
};
